var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.$vuetify.breakpoint.mobile,
      expression: "!$vuetify.breakpoint.mobile"
    }],
    staticClass: "visual"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_vm._m(0), _vm._m(1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('router-link', {
    staticClass: "background background--2",
    attrs: {
      "to": "/join"
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/main/banner-pc2.jpg",
      "alt": ""
    }
  })])], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('router-link', {
    staticClass: "background background--3",
    attrs: {
      "to": "/gshop/brand"
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/main/banner-pc3.jpg",
      "alt": ""
    }
  })])], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('router-link', {
    staticClass: "background background--4",
    attrs: {
      "to": "/shop/discount"
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/main/banner-pc4.jpg",
      "alt": ""
    }
  })])], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('router-link', {
    staticClass: "background background--5",
    attrs: {
      "to": "/shop/independent"
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/main/banner-pc5.jpg",
      "alt": ""
    }
  })])], 1), _vm._m(2)])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "swiper-slide"
  }, [_c('a', {
    staticClass: "background background--7",
    attrs: {
      "href": "https://smartstore.naver.com/korea-books/products/9569341704?NaPm=ct%3Dlu6lheh4%7Cci%3Da28d13e3474197d3d86794830e2b632e3b2e5609%7Ctr%3Dsls%7Csn%3D627310%7Chk%3D2ec2dd599537149cc34a8018bc4d870bff09308d",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/main/banner-pc7.jpg",
      "alt": ""
    }
  })])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "swiper-slide"
  }, [_c('a', {
    staticClass: "background background--1",
    attrs: {
      "href": "/shop/ebook"
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/main/banner-pc1.jpg",
      "alt": ""
    }
  })])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "swiper-slide"
  }, [_c('a', {
    staticClass: "background background--6",
    attrs: {
      "href": "https://www.daehanbooks.co.kr/shop/bestseller",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/main/banner-pc6.jpg",
      "alt": ""
    }
  })])]);
}]

export { render, staticRenderFns }